export default "__VITE_ASSET__Bvy60BIx__"